package com.swetdot.swetgram.web

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.swetdot.swetgram.App
import com.swetdot.swetgram.createBrowserAppContainer
import com.swetdot.swetgram.ui.links.openExternalLink
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        MainScope().launch {
            try {
                val container = createBrowserAppContainer()
                val path = js("window.location.pathname") as String
                openExternalLink("https://swetgram.com$path")
                ComposeViewport("app") { App(container) }
                js("document.getElementById('loading').remove()")
            } catch (error: Throwable) {
                // Do not log credentials or server response bodies in the startup UI.
                js("document.getElementById('loading').textContent = 'Не удалось загрузить Swetgram. Обновите страницу.'")
            }
        }
    }
}
